// import React, { useEffect, useState, useContext } from "react";
// import { API_URL } from "../config";
// import { AuthContext } from '../App';
// import { hasPermission } from "../utils/permissions";
// import {
//   Typography,
//   Box,
//   Toolbar,
//   Container,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Snackbar,
//   IconButton,
//   CircularProgress,
// } from "@mui/material";
// import { Add, Edit, Delete } from "@mui/icons-material";
// import AdminSidebar from "../AdminSidebar";
// import Forbidden403 from "../components/common/Forbidden403";


// /**
//  * Organizations admin page for listing, creating, editing, and deleting organizations.
//  * Integrates with backend API using JWT authentication.
//  */
// export default function Organizations() {
//   const { fetchWithAuth, auth } = useContext(AuthContext);
//   const hasListPermission = hasPermission(auth?.user, "organization.list");
//   if (!hasListPermission) {
//     return (
//       <Box sx={{ display: 'flex', minHeight: '100vh', background: '#f7f7fa' }}>
//         <AdminSidebar selected="Organizations" />
//         <Box sx={{ flex: 1, p: 3, mt: 7, mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Forbidden403 message="You are not authorized to view organizations. Please contact your system administrator." />
//         </Box>
//       </Box>
//     );
//   }
  
//   const [organizations, setOrganizations] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [openDialog, setOpenDialog] = useState(false);
//   const [dialogMode, setDialogMode] = useState("create"); // 'create' | 'edit'
//   const [selectedOrg, setSelectedOrg] = useState(null);
//   const [orgName, setOrgName] = useState("");
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const [deleteDialog, setDeleteDialog] = useState({ open: false, org: null });

  

//   // Get token from auth context via fetchWithAuth
//   const token = fetchWithAuth?.auth?.access_token || "";

//   /** Fetch organizations from backend API */
//   const fetchOrganizations = async () => {
//     setLoading(true);
//     setError("");
//     try {
//       const res = await fetchWithAuth(`${API_URL}/organizations/`);
//       if (!res.ok) {
//         if (res.status === 403) {
//           setError(
//             "You are not authorized to perform this action. Please contact your system administrator."
//           );
//           return;
//         }
//         throw new Error("Failed to fetch organizations");
//       }
//       const data = await res.json();
//       setOrganizations(data);
//     } catch (err) {
//       setError(err.message || "Error fetching organizations");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrganizations();
//     // eslint-disable-next-line
//   }, []);

//   /** Open dialog for creating or editing */
//   const handleOpenDialog = (mode, org = null) => {
//     setDialogMode(mode);
//     setSelectedOrg(org);
//     setOrgName(org ? org.name : "");
//     setOpenDialog(true);
//   };

//   /** Close dialog and reset state */
//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedOrg(null);
//     setOrgName("");
//   };

//   /** Handle create or update organization */
//   const handleSaveOrg = async () => {
//     if (!orgName.trim()) {
//       setSnackbar({
//         open: true,
//         message: "Organization name is required",
//         severity: "error",
//       });
//       return;
//     }
//     try {
//       setLoading(true);
//       let res;
//       if (dialogMode === "create") {
//         res = await fetchWithAuth(`${API_URL}/organizations/`, {
//           method: "POST",
//           body: JSON.stringify({ name: orgName }),
//         });
//       } else {
//         res = await fetchWithAuth(`${API_URL}/organizations/${selectedOrg.id}`, {
//           method: "PUT",
//           body: JSON.stringify({ name: orgName }),
//         });
//       }
//       if (!res.ok) {
//         const errData = await res.json();
//         throw new Error(errData.detail || "Failed to save organization");
//       }
//       setSnackbar({
//         open: true,
//         message:
//           dialogMode === "create"
//             ? "Organization created"
//             : "Organization updated",
//         severity: "success",
//       });
//       handleCloseDialog();
//       fetchOrganizations();
//     } catch (err) {
//       setSnackbar({
//         open: true,
//         message: err.message || "Error saving organization",
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   /** Open delete confirmation dialog */
//   const handleOpenDelete = (org) => {
//     setDeleteDialog({ open: true, org });
//   };

//   /** Close delete confirmation dialog */
//   const handleCloseDelete = () => {
//     setDeleteDialog({ open: false, org: null });
//   };

//   /** Handle delete organization */
//   const handleDeleteOrg = async () => {
//     try {
//       setLoading(true);
//       const res = await fetchWithAuth(
//         `${API_URL}/organizations/${deleteDialog.org.id}`,
//         {
//           method: "DELETE",
//         }
//       );
      
//       // Handle empty response (204 No Content)
//       if (res.status === 204) {
//         setSnackbar({
//           open: true,
//           message: "Organization deleted successfully",
//           severity: "success",
//         });
//         handleCloseDelete();
//         fetchOrganizations();
//         return;
//       }
      
//       // For error responses, try to parse JSON
//       const data = await res.json().catch(() => ({}));
      
//       if (!res.ok) {
//         // Handle the error message from the backend
//         const errorMessage = data?.error?.message || data?.detail || "Failed to delete organization";
//         throw new Error(errorMessage);
//       }
//       handleCloseDelete();
//       fetchOrganizations();
//     } catch (err) {
//       setSnackbar({
//         open: true,
//         message: err.message || "Error deleting organization",
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ display: "flex" }}>
//       <AdminSidebar selected="Organizations" />
//       <Box component="main" sx={{ flexGrow: 1, pl: 3, pr: 2, pt: 2 }}>
//         <Toolbar />
//         <Container
//           maxWidth="md"
//           sx={{ py: { xs: 2, sm: 4 }, px: { xs: 1, sm: 3 } }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 2,
//             }}
//           >
//             <Typography variant="h5" sx={{ fontWeight: 700 }}>
//               Organizations
//             </Typography>
//             <Button
//               variant="contained"
//               startIcon={<Add />}
//               onClick={() => handleOpenDialog("create")}
//             >
//               Add Organization
//             </Button>
//           </Box>
//           {loading ? (
//             <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
//               <CircularProgress />
//             </Box>
//           ) : error ? (
//             <Typography color="error">{error}</Typography>
//           ) : (
//             <TableContainer component={Paper} sx={{ mt: 1 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Name</TableCell>
//                     <TableCell>Owner</TableCell>
//                     <TableCell align="right">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {organizations.map((org) => (
//                     <TableRow key={org.id}>
//                       <TableCell>{org.name}</TableCell>
//                       <TableCell>{org.owner_id || "-"}</TableCell>
//                       <TableCell align="right">
//                         <IconButton
//                           size="small"
//                           onClick={() => handleOpenDialog("edit", org)}
//                           aria-label="edit"
//                         >
//                           <Edit fontSize="small" />
//                         </IconButton>
//                         <IconButton
//                           size="small"
//                           onClick={() => handleOpenDelete(org)}
//                           aria-label="delete"
//                           color="error"
//                         >
//                           <Delete fontSize="small" />
//                         </IconButton>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           )}
//         </Container>
//         {/* Create/Edit Dialog */}
//         <Dialog
//           open={openDialog}
//           onClose={handleCloseDialog}
//           fullWidth
//           maxWidth="xs"
//         >
//           <DialogTitle>
//             {dialogMode === "create" ? "Add Organization" : "Edit Organization"}
//           </DialogTitle>
//           <DialogContent>
//             <TextField
//               autoFocus
//               margin="dense"
//               label="Organization Name"
//               type="text"
//               fullWidth
//               value={orgName}
//               onChange={(e) => setOrgName(e.target.value)}
//               disabled={loading}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDialog} disabled={loading}>
//               Cancel
//             </Button>
//             <Button
//               onClick={handleSaveOrg}
//               variant="contained"
//               disabled={loading}
//             >
//               {dialogMode === "create" ? "Create" : "Update"}
//             </Button>
//           </DialogActions>
//         </Dialog>
//         {/* Delete Confirmation Dialog */}
//         <Dialog open={deleteDialog.open} onClose={handleCloseDelete}>
//           <DialogTitle>Delete Organization</DialogTitle>
//           <DialogContent>
//             <Typography>
//               Are you sure you want to delete this organization?
//             </Typography>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDelete} disabled={loading}>
//               Cancel
//             </Button>
//             <Button
//               onClick={handleDeleteOrg}
//               color="error"
//               variant="contained"
//               disabled={loading}
//             >
//               Delete
//             </Button>
//           </DialogActions>
//         </Dialog>
//         {/* Snackbar for notifications */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={4000}
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           message={snackbar.message}
//           anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         />
//       </Box>
//     </Box>
//   );
// }


import React, { useEffect, useState, useContext } from "react";
import { API_URL } from "../config";
import { AuthContext } from "../App";
import { hasPermission } from "../utils/permissions";
import {
  Typography,
  Box,
  Toolbar,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Snackbar,
  IconButton,
  CircularProgress,
  Alert,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { Add, Edit, Delete } from "@mui/icons-material";
import AdminSidebar from "../AdminSidebar";
import Forbidden403 from "../components/common/Forbidden403";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

/**
 * Organizations admin page for listing, creating, editing, and deleting organizations.
 * Integrates with backend API using JWT authentication.
 */
export default function Organizations() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const panelBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const { fetchWithAuth, auth } = useContext(AuthContext);
  const hasListPermission = hasPermission(auth?.user, "organization.list");

  if (!hasListPermission) {
    return (
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
        <AdminSidebar selected="Organizations" />
        <Box
          sx={{
            flex: 1,
            p: 3,
            mt: 7,
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Forbidden403 message="You are not authorized to view organizations. Please contact your system administrator." />
        </Box>
      </Box>
    );
  }

  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMode, setDialogMode] = useState("create");
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [orgName, setOrgName] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, org: null });

  const fetchOrganizations = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetchWithAuth(`${API_URL}/organizations/`);
      if (!res.ok) {
        if (res.status === 403) {
          setError(
            "You are not authorized to perform this action. Please contact your system administrator."
          );
          return;
        }
        throw new Error("Failed to fetch organizations");
      }
      const data = await res.json();
      setOrganizations(data);
    } catch (err) {
      setError(err.message || "Error fetching organizations");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const handleOpenDialog = (mode, org = null) => {
    setDialogMode(mode);
    setSelectedOrg(org);
    setOrgName(org ? org.name : "");
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedOrg(null);
    setOrgName("");
  };

  const handleSaveOrg = async () => {
    if (!orgName.trim()) {
      setSnackbar({
        open: true,
        message: "Organization name is required",
        severity: "error",
      });
      return;
    }

    try {
      setLoading(true);
      let res;

      if (dialogMode === "create") {
        res = await fetchWithAuth(`${API_URL}/organizations/`, {
          method: "POST",
          body: JSON.stringify({ name: orgName }),
        });
      } else {
        res = await fetchWithAuth(`${API_URL}/organizations/${selectedOrg.id}`, {
          method: "PUT",
          body: JSON.stringify({ name: orgName }),
        });
      }

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Failed to save organization");
      }

      setSnackbar({
        open: true,
        message:
          dialogMode === "create"
            ? "Organization created"
            : "Organization updated",
        severity: "success",
      });

      handleCloseDialog();
      fetchOrganizations();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "Error saving organization",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDelete = (org) => {
    setDeleteDialog({ open: true, org });
  };

  const handleCloseDelete = () => {
    setDeleteDialog({ open: false, org: null });
  };

  const handleDeleteOrg = async () => {
    try {
      setLoading(true);
      const res = await fetchWithAuth(
        `${API_URL}/organizations/${deleteDialog.org.id}`,
        {
          method: "DELETE",
        }
      );

      if (res.status === 204) {
        setSnackbar({
          open: true,
          message: "Organization deleted successfully",
          severity: "success",
        });
        handleCloseDelete();
        fetchOrganizations();
        return;
      }

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const errorMessage =
          data?.error?.message ||
          data?.detail ||
          "Failed to delete organization";
        throw new Error(errorMessage);
      }

      handleCloseDelete();
      fetchOrganizations();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "Error deleting organization",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
      <AdminSidebar selected="Organizations" />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pl: { xs: 1.5, md: 3 },
          pr: { xs: 1.5, md: 3 },
          pt: 2,
          pb: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />

        <Container maxWidth="xl" disableGutters sx={{ mt: 1 }}>
          <Box
            sx={{
              mb: 3,
              overflow: "hidden",
              borderRadius: "28px",
              border: `1px solid ${border}`,
              background: dark
                ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
                : `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
              boxShadow: dark
                ? "0 32px 80px rgba(0,0,0,0.30)"
                : "0 32px 80px rgba(15,15,26,0.08)",
            }}
          >
            <Box
              sx={{
                p: { xs: 3, sm: 4, md: 5 },
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Box>
                <SectionEyebrow color={accent}>AjiraHQ · Organizations</SectionEyebrow>
                <Typography
                  sx={{
                    mt: 2,
                    color: text,
                    fontWeight: 800,
                    fontSize: "clamp(30px, 4vw, 44px)",
                    lineHeight: 1.06,
                    letterSpacing: "-0.03em",
                    mb: 0.75,
                  }}
                >
                  Manage organizations.
                </Typography>
                <Typography
                  sx={{
                    color: mid,
                    fontSize: "15px",
                    lineHeight: 1.8,
                    maxWidth: 620,
                  }}
                >
                  Create, edit, and maintain organization records.
                </Typography>
              </Box>

              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => handleOpenDialog("create")}
                sx={{
                  textTransform: "none",
                  fontWeight: 700,
                  borderRadius: "12px",
                  px: 2.5,
                  py: 1.1,
                  background: accent,
                  boxShadow: `0 14px 34px ${alpha(accent, 0.22)}`,
                  "&:hover": {
                    background: accent,
                    filter: "brightness(1.08)",
                  },
                }}
              >
                Add Organization
              </Button>
            </Box>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: "22px",
              background: panelBg,
              border: `1px solid ${border}`,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.20)"
                : "0 12px 30px rgba(15,23,42,0.06)",
            }}
          >
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 260,
                }}
              >
                <CircularProgress sx={{ color: accent }} />
              </Box>
            ) : error ? (
              <Alert severity="error" sx={{ borderRadius: "18px" }}>
                {error}
              </Alert>
            ) : (
              <TableContainer
                sx={{
                  borderRadius: "18px",
                  border: `1px solid ${border}`,
                  overflowX: "auto",
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {["Name", "Owner", "Actions"].map((header) => (
                        <TableCell
                          key={header}
                          sx={{
                            fontWeight: 700,
                            color: mid,
                            background: dark ? "#111827" : "#fafafa",
                            borderBottom: `1px solid ${border}`,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {organizations.map((org) => (
                      <TableRow
                        key={org.id}
                        hover
                        sx={{
                          "& td": {
                            borderBottom: `1px solid ${border}`,
                            background: dark ? "rgba(13,18,32,0.96)" : "#ffffff",
                            color: mid,
                          },
                          "&:hover td": {
                            background: dark
                              ? "rgba(255,255,255,0.03)"
                              : "rgba(15,15,26,0.02)",
                          },
                        }}
                      >
                        <TableCell sx={{ color: text, fontWeight: 700 }}>
                          {org.name}
                        </TableCell>

                        <TableCell>{org.owner_id || "-"}</TableCell>

                        <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                          <IconButton
                            size="small"
                            onClick={() => handleOpenDialog("edit", org)}
                            aria-label="edit"
                            sx={{ color: mid, mr: 0.5 }}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => handleOpenDelete(org)}
                            aria-label="delete"
                            sx={{ color: "#dc2626" }}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}

                    {organizations.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          <Typography sx={{ py: 3, color: muted }}>
                            No organizations found.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </Container>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle
            sx={{
              fontWeight: 800,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            {dialogMode === "create" ? "Add Organization" : "Edit Organization"}
          </DialogTitle>

          <DialogContent dividers>
            <TextField
              autoFocus
              margin="dense"
              label="Organization Name"
              type="text"
              fullWidth
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
              disabled={loading}
            />
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseDialog} disabled={loading}>
              Cancel
            </Button>
            <Button
              onClick={handleSaveOrg}
              variant="contained"
              disabled={loading}
            >
              {dialogMode === "create" ? "Create" : "Update"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={deleteDialog.open} onClose={handleCloseDelete}>
          <DialogTitle
            sx={{
              fontWeight: 800,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            Delete Organization
          </DialogTitle>

          <DialogContent dividers>
            <Typography sx={{ color: mid }}>
              Are you sure you want to delete this organization?
            </Typography>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseDelete} disabled={loading}>
              Cancel
            </Button>
            <Button
              onClick={handleDeleteOrg}
              color="error"
              variant="contained"
              disabled={loading}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}